import { Box, CircularProgress, Dialog, DialogContent, Typography } from '@mui/material';
import React from 'react';
import QrCodeComp from '../../../../components/QrCodeComp';

function DialogAuthenticationLocker({ open, onClose, obtainedPath, loadingQrCode }) {
  const handleClose = () => {
    onClose(false);
  };
  return (
    <Dialog
      open={open}
      // onClose={handleClose}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      {/* <DialogTitle id="alert-dialog-title">Titulo del dialogo</DialogTitle> */}
      <DialogContent>
        {loadingQrCode && <CircularProgress />}
        {!loadingQrCode && (
          <Box sx={{ padding: '15px', display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '10px' }}>
            <QrCodeComp value={obtainedPath} />
          </Box>
        )}
      </DialogContent>
    </Dialog>
  );
}

export default DialogAuthenticationLocker;
